export default __webpack_public_path__ + "static/media/11.c5bda67b.md";